import type { ChatMode } from "@storytell/cp-client";

/** gRPC / Connect `Code.PermissionDenied` (no `@connectrpc/connect` import — avoids extra app dependency). */
const GRPC_PERMISSION_DENIED = 7;

function isPermissionDeniedError(error: unknown): boolean {
  if (error !== null && typeof error === "object" && "code" in error) {
    const code = error.code;
    if (code === GRPC_PERMISSION_DENIED) {
      return true;
    }
    if (code === "permission_denied" || code === "PERMISSION_DENIED") {
      return true;
    }
  }
  const msg = (error instanceof Error ? error.message : String(error)).toLowerCase();
  return msg.includes("permission_denied") || msg.includes("permission denied") || msg.includes("[permission_denied]");
}

/**
 * True when the user submitted in Research mode and the chat stream failed with
 * permission denied (existing BE plan / feature gating for research only).
 */
export function isChatStreamFeatureGatePermissionError(mode: ChatMode | undefined, error: unknown): boolean {
  if (mode !== "research") {
    return false;
  }
  return isPermissionDeniedError(error);
}

/** gRPC / Connect `Code.ResourceExhausted`. */
const GRPC_RESOURCE_EXHAUSTED = 8;

/**
 * True when the stream was refused because the billing org has no credits. Rate limiting shares
 * the resource-exhausted code, so the server's error type name has to be in the message too.
 */
export function isChatStreamInsufficientCreditsError(error: unknown): boolean {
  if (error === null || typeof error !== "object" || !("code" in error)) return false;
  if (error.code !== GRPC_RESOURCE_EXHAUSTED) return false;
  const msg = "message" in error && typeof error.message === "string" ? error.message : "";
  return msg.includes("insufficient_credits");
}
